import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <h2 className="section-title">About Our Journal</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="highlight">
              <strong>Napier Indian Advanced Research Journal of Sciences (NIARJS)</strong> is a prestigious national multidisciplinary peer-reviewed research journal.
            </p>
            <p>
              Established in <strong>2008</strong>, our journal has been at the forefront of disseminating high-quality research across various scientific disciplines. We are committed to promoting excellence in scientific research and fostering academic collaboration.
            </p>
            <div className="about-features">
              <div className="feature-card">
                <div className="feature-icon">📚</div>
                <h3>Peer Reviewed</h3>
                <p>Rigorous peer review process ensuring quality publications</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🌐</div>
                <h3>Multidisciplinary</h3>
                <p>Covering diverse fields of scientific research</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🏆</div>
                <h3>National Recognition</h3>
                <p>Recognized journal with ISSN certification</p>
              </div>
            </div>
          </div>
          <div className="about-stats">
            <div className="stat-box">
              <h3>17+</h3>
              <p>Years of Excellence</p>
            </div>
            <div className="stat-box">
              <h3>ISSN</h3>
              <p>0975-1726</p>
            </div>
            <div className="stat-box">
              <h3>Half Yearly</h3>
              <p>Publication Frequency</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
